<template>
    <div role="button"
         :class="`choice ${activeStateModifier}${disabled ? ' --disabled' : ''}`"
         tabindex="0"
         @keyup.enter="$emit('click', value)"
         @click="$emit('click', value)">
        <button :id="`choice-${value}`"
                :class="`choice__button --${value}${this.imageUrl ? ' --image' : ''}`"
                :disabled="disabled"
                tabindex="-1"
                role="none"
                @keyup.enter="$emit('click', value)"
                @click="$emit('click', value)">
            <div v-if="imageUrl"
                 class="choice__button__image" :style="`background-image: url(${this.imageUrl})`" />
            <span class="choice__button__text">{{ text }}</span>
        </button>
    </div>
</template>

<script>

const baseChoice = {

    props: {
        text: {
            type: [ String, Number ],
            required: true,
        },
        value: {
            type: [ String, Number ],
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        active: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        activeStateModifier() {
            return this.active ? '--active' : '--inactive'
        },
    },
}

export { baseChoice }

export default {

    mixins: [
        baseChoice,
    ],

    props: {
        imageUrl: {
            type: String,
            default: null,
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\plan-chooser\_choice.scss

.choice {
    margin: 0;
    cursor: pointer;

    @include element('button') {
        border: none;
        padding: 0;
        margin: 0;
        width: 100%;
        cursor: pointer;

        @include element('text') {
            display: block;
            padding: 0.7rem;

            @include bp-min-mid {
                padding: 1rem 1.5rem;
            }

            @include bp-min-wide {
                padding: 1.5rem;
            }
        }

        @include element('image') {
            background-repeat: no-repeat;
            background-position: bottom;
            background-size: cover;
            width: 100%;
            height: rem(100px);
        }
    }

    &.--active {

        > button {
            cursor: default;
        }
    }

    &.--disabled {
        cursor: default;

        > button {
            cursor: default;
        }
    }
}

</style>
